import React from 'react';
import { Box, Grid, Typography } from '@mui/material';
import LocalShippingOutlinedIcon from '@mui/icons-material/LocalShippingOutlined';
import DirectionsCarFilledOutlinedIcon from '@mui/icons-material/DirectionsCarFilledOutlined';
import TwoWheelerOutlinedIcon from '@mui/icons-material/TwoWheelerOutlined';
import PrecisionManufacturingOutlinedIcon from '@mui/icons-material/PrecisionManufacturingOutlined';
import AirportShuttleOutlinedIcon from '@mui/icons-material/AirportShuttleOutlined';
import { FONT_FAMILY } from "../common/sharedFunctions";
import { MOVEX_UI } from '../common/movexUiTheme';

const services = [
    {
        icon: <DirectionsCarFilledOutlinedIcon style={{ color: MOVEX_UI.accent, fontSize: 38 }} />,
        title: 'Grúa para carro',
        text: 'Servicio de grúa para carro a domicilio en Colombia. Si tu auto se varó, chocó o necesitas trasladarlo, pide una grúa plataforma o de gancho con precio y tiempo estimado antes de confirmar, conductor verificado y seguimiento en tiempo real.',
    },
    {
        icon: <TwoWheelerOutlinedIcon style={{ color: MOVEX_UI.accent, fontSize: 38 }} />,
        title: 'Grúa para moto',
        text: 'Grúa para moto segura y rápida. Trasladamos tu motocicleta con anclajes adecuados para evitar daños, ideal tras una avería, accidente o pico y placa. Solicita la grúa para moto más cercana desde la app.',
    },
    {
        icon: <PrecisionManufacturingOutlinedIcon style={{ color: MOVEX_UI.accent, fontSize: 38 }} />,
        title: 'Grúas para maquinaria',
        text: 'Grúas para maquinaria pesada y equipos industriales. Movilizamos montacargas, retroexcavadoras y maquinaria de construcción con grúas de plataforma de alta capacidad y operadores especializados en toda Colombia.',
    },
    {
        icon: <AirportShuttleOutlinedIcon style={{ color: MOVEX_UI.accent, fontSize: 38 }} />,
        title: 'Grúa niñera',
        text: 'Grúa niñera (plataforma camabaja) para transportar uno o varios vehículos a la vez sobre la plataforma, sin rodar sus llantas. Perfecta para autos de alta gama, vehículos sin tracción o traslados largos.',
    },
    {
        icon: <LocalShippingOutlinedIcon style={{ color: MOVEX_UI.accent, fontSize: 38 }} />,
        title: 'Servicio de grúa y auxilio vial 24/7',
        text: 'Servicio de grúa y auxilio vial cerca de ti las 24 horas en Bogotá, Medellín, Cali, Barranquilla, Cartagena y todo Colombia. Cambio de llanta, paso de corriente, combustible y remolque con evidencia fotográfica del vehículo.',
    },
];

const SeoServices = () => {
    return (
        <Box
            component="section"
            sx={{
              background: MOVEX_UI.heroGradient,
              color: '#fff',
              px: { xs: 2, md: 8 },
              py: { xs: 5, md: 8 },
            }}
        >
            <Typography
                component="h2"
                sx={{ fontFamily: FONT_FAMILY, fontWeight: 800, fontSize: { xs: 26, md: 36 }, textAlign: 'center', mb: 1 }}
            >
                Grúas en Colombia para carro, moto, maquinaria y grúa niñera
            </Typography>
            <Typography
                component="p"
                sx={{ fontFamily: FONT_FAMILY, fontSize: { xs: 15, md: 18 }, textAlign: 'center', color: 'rgba(255,255,255,0.72)', maxWidth: 900, mx: 'auto', mb: 5 }}
            >
                Movex es la app tipo Uber para grúas: solicita una grúa cerca de ti en minutos,
                con precio y tiempo estimado antes de confirmar, conductor verificado, seguimiento
                en tiempo real y evidencia con fotos del vehículo.
            </Typography>

            <Grid container spacing={3} justifyContent="center">
                {services.map((s, i) => (
                    <Grid item xs={12} sm={6} md={4} key={i}>
                        <Box
                            className="ai-glow-card"
                            sx={{
                                backgroundColor: 'rgba(255,255,255,0.04)',
                                border: '1px solid rgba(255,255,255,0.1)',
                                borderRadius: MOVEX_UI.radiusLg,
                                p: 3,
                                height: '100%',
                                transition: 'transform .2s ease, border-color .2s ease, box-shadow .2s ease',
                                '&:hover': {
                                  transform: 'translateY(-4px)',
                                  borderColor: MOVEX_UI.accent,
                                  boxShadow: '0 16px 40px rgba(6, 200, 109, 0.15)',
                                },
                            }}
                        >
                            {s.icon}
                            <Typography
                                component="h3"
                                sx={{ fontFamily: FONT_FAMILY, fontWeight: 700, fontSize: 20, mt: 1.5, mb: 1 }}
                            >
                                {s.title}
                            </Typography>
                            <Typography
                                component="p"
                                sx={{ fontFamily: FONT_FAMILY, fontSize: 15, color: 'rgba(255,255,255,0.68)', lineHeight: 1.6 }}
                            >
                                {s.text}
                            </Typography>
                        </Box>
                    </Grid>
                ))}
            </Grid>
        </Box>
    );
};

export default SeoServices;
